// extracted by mini-css-extract-plugin
export default {"Prline":"prline_Prline__D2jF7","Prline__new":"prline_Prline__new__ZJPzP"};